export default {
  namespaced: true,
  institutions: {
    title: 'Institutions | Institution',
    name: 'name',
    description: 'description',
    tenant: 'Tenant',
    institutions: 'Institutions',
    select: 'Select one or more institutions'
  }
}
